module.exports = __webpack_public_path__ + "static/media/APDocument2024-25.84b9ef2f.pdf";